import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { DatabaseState } from 'services/database-wrapper';
import { PubSubService, PubSubRegistration } from 'services/pubsub.service';
import { ConnectionStateService, DebouncedCloudStateChangeEvent } from 'services/connection-state.service';

@Component({
  selector: 'cs-header-progress',
  templateUrl: 'cs-header-progress.html',
  host: { 'class': 'header-progress' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsHeaderProgressComponent implements OnInit, OnDestroy {
  cloudSyncState: DatabaseState = undefined;
  private cloudStateSub: PubSubRegistration;

  @HostBinding('hidden')
  get hidden(): boolean {
    return !this.visible;
  }

  @HostBinding('class.offline')
  get offlineClass(): boolean {
    return this.isOffline;
  }

  @HostBinding('class.syncing')
  get syncingClass(): boolean {
    return this.isSyncing;
  }

  constructor(
    private cd: ChangeDetectorRef,
    private pubSub: PubSubService,
    
    private connectionStateService: ConnectionStateService
  ) { }

  ngOnInit() {
    // Initialize state from service
    this.cloudSyncState = this.connectionStateService.debouncedState;

    // Subscribe to debounced cloud state changes
    this.cloudStateSub = this.pubSub.subscribe(DebouncedCloudStateChangeEvent, (data: { state: DatabaseState }) => {
      this.updateCloudStatus(data.state);
    });
  }

  ngOnDestroy() {
    if (this.cloudStateSub) {
      this.cloudStateSub.unsubscribe();
    }
  }

  get visible(): boolean {
    // Show when syncing or offline
    return this.cloudSyncState === DatabaseState.Syncing || this.cloudSyncState === DatabaseState.Offline;
  }

  get isSyncing(): boolean {
    return this.cloudSyncState === DatabaseState.Syncing;
  }

  get isOffline(): boolean {
    return this.cloudSyncState === DatabaseState.Offline;
  }

  // purely visual: render whatever the debounced state currently is. The offline / back-online
  // TOAST is announced once at app level (ConnectivityResumeFlow.announceCloudStateTransition) — it must
  // not live here, because this component comes and goes with the page, and a transition that
  // happened while it was unmounted would never be announced at all (#3991).
  private updateCloudStatus(state: DatabaseState) {
    this.cloudSyncState = state;
    this.cd.markForCheck();
  }
}
